import { Api } from '../api';
import { cards } from '../endpoints';
import type { ApiPaginate, ApiResponse } from '../../models';
import type {
  CardDetailsResponse,
  CardLimitsResponse,
  CardResponse,
  CardsByAccountsRequestData,
  CardsRequest,
  RemindPinRequest,
  RemindPinResponse,
  ReportLostStolenRequest,
  UpdateCategoryCardRequest,
  UpdateLabelCardRequest,
  UpdateLimitCardRequest,
} from './models';

export class CardsApi extends Api {
  static getCards = (request: CardsRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<CardResponse[]>>({ url: cards.getCards(), queryParams: request, signal });

  static getCardsByAccounts = (request: CardsByAccountsRequestData, signal?: AbortSignal) =>
    this.post<CardsByAccountsRequestData, ApiPaginate<CardResponse[]>>({ url: cards.getCardsByAccounts(), data: request, signal });

  static getCard = (cardId: number, signal?: AbortSignal) => this.get<ApiResponse<CardDetailsResponse>>({ url: cards.getCard(cardId), signal });

  static freezeCard = (cardId: number, signal?: AbortSignal) =>
    this.put<null, ApiResponse<CardDetailsResponse>>({ url: cards.freezeCard(cardId), signal });

  static unFreezeCard = (cardId: number, signal?: AbortSignal) =>
    this.put<null, ApiResponse<CardDetailsResponse>>({ url: cards.unfreezeCard(cardId), signal });

  static remindPin = (request: RemindPinRequest, signal?: AbortSignal) =>
    this.post<RemindPinRequest, ApiResponse<RemindPinResponse>>({ url: cards.remindPin(request.cardId), data: request, signal });

  static updateLabelCard = (request: UpdateLabelCardRequest, signal?: AbortSignal) =>
    this.put<UpdateLabelCardRequest, ApiResponse<CardDetailsResponse>>({ url: cards.updateLabel(request.cardId), signal, data: request });

  static updateLimitCard = (request: UpdateLimitCardRequest, signal?: AbortSignal) =>
    this.put<UpdateLimitCardRequest, ApiResponse<CardLimitsResponse>>({ url: cards.updateLimit(request?.cardUUId ?? ''), signal, data: request });

  static updateCategoryCard = (request: UpdateCategoryCardRequest, signal?: AbortSignal) =>
    this.put<UpdateCategoryCardRequest, ApiResponse<CardDetailsResponse>>({ url: cards.updateCategory(request.cardId), signal, data: request });

  static getLimits = (request: number, signal?: AbortSignal) => this.get<ApiResponse<CardLimitsResponse>>({ url: cards.getLimits(request), signal });

  static activate = (request: number, signal?: AbortSignal) => this.put<null, ApiResponse<null>>({ url: cards.activate(request), signal });

  static reportLostStolen = (request: ReportLostStolenRequest, signal?: AbortSignal) =>
    this.post<ReportLostStolenRequest, ApiResponse<CardDetailsResponse>>({ url: cards.reportLostStolen(request.cardId), data: request, signal });
}
